import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

export const LinkItem = styled(NavLink)`
  text-decoration: none;
`;

export const EventItemWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;

  background: var(--background-secondary-color);
  border-radius: 1em;
  height: 400px;
  margin-bottom: 1em;
  position: relative;
  overflow: hidden;

  text-decoration: none;

  ${(props) => props.bgImage && css`
    background-image: url('${props.bgImage}');
    background-repeat: no-repeat;
    background-size: cover;
  `}
`;

export const EventItemDescription = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  background-color: var(--event-item-bg-color);
  color: var(--text-color);
  margin-top: auto;
  padding: 1em;
`;

export const EventItemInfo = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
`;

export const EventItemTitle = styled.p`
  font-weight: 600;
  margin: 0;
`;

export const EventItemText = styled.div`

`;

export const EventItemType = styled.div`
  background-color: #2984e8;
  border: 1px solid white;
  border-radius: 1em;
  color: #fff;
  line-height: 1;
  padding: 0.5em 1em;
`;

export const EventDateWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  padding: 0.5em;
  min-width: 45px;

  position: absolute;
  top: 1em;
  right: 1em;

  background-color: #be0a8d;
  border-radius: 0.5em;
  box-shadow: 0 3px 5px -2px rgba(0, 0, 0, 0.7);
  color: #ffffff;
`;

export const EventDateDayWeek = styled.p`
  text-transform: uppercase;
  font-size: 1em;
  font-weight: 900;
  line-height: 1;
  margin: 0;
`;

export const EventDateDay = styled.p`
  font-size: 1.6em;
  font-weight: 900;
  line-height: 1.2;
  margin: 0;
`;

export const EventDateMonth = styled.p`
  text-transform: uppercase;
  font-weight: 400;
  margin: 0;
  line-height: 1;
`;
